<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.loadThumbnail}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="product.title | safeHtml"></span>
	</h5>
</div>
<div class="modal-body thumbs-loader">
	<div style="max-height:400px;overflow-y:auto;overflow-x:hidden">
		<div class="col-sm-4 hidden-xs">
              <div style="padding-top:0px">
               <img [src]="product._thumbs" class='img-thumbnail img-responsive' alt="Thumbnail for {{product.title}}">
              </div>
		</div>
		<div class="col-sm-8 col-xs-12">
				<div class="dropzone background-light" dropzone (filesSelected)="onFilesSelected($event)">
					<div style="flex:1">
						<div>
							<p>
								<em>{{ LOCALIZATION.dragDropRecordsLimit | formatString: 1 }}. </em>
								<em>{{ LOCALIZATION.dragDropRecordsValidThumbTypes }}</em>
							</p>
						</div>
						<label 
						    for="file-upload" 
						    class="btn btn-circle btn-lg btn-primary z-depth-1" 
						    title="{{LOCALIZATION.addFile}}">
						    <i class="fa fa-file" aria-hidden="true"></i>
						</label>
						<input id="file-upload"
						       type="file" 
						       accept=".jpg,.jpeg,.png,.gif,.bmp,.webp" 
						       fileinput 
						       (filesSelected)="onFilesSelected($event)" 
						       class="hidden-input" />
					</div>
				</div>
			<div>
				<div *ngIf="uploadFiles && uploadFiles.length > 0">
					<div *ngIf="ingestMsg" class="alert alert-{{ingestMsgType}}" role="alert" style="white-space:pre-wrap;">{{ingestMsg}}</div>
					<div *ngFor="let file of uploadFiles; let i = index;"
						class="col-xs-12 z-depth-1" [ngClass]="{'invalid-field': file.invalid}"
						style="margin-bottom: 5px;padding: 5px;border-radius: 5px;">
						<div style="display:flex;">
							<div style="flex:1;text-align:center">
								<img [src]="file.currentFileSrc" class="img-responsive" alt="Preview for {{file.file.name}}" style="max-width:60px">
							</div>
							<div style="flex:3;text-align:center;" class="truncate">
								<span title="{{file.file.name}}">{{file.file.name}}</span>
								<p title="{{file.sizeStr}}" ><em>{{file.sizeStr}}</em></p>
							</div>
							<div style="flex:1;">
								<span class="pull-left" *ngIf="file.ready === 'SUCCESS'">{{LOCALIZATION.added}}</span>
								<span class="pull-left" *ngIf="file.ready === 'FAIL'">{{LOCALIZATION.failed}}</span>
								<i class="fa fa-times fa-1x text-red pointMe pull-right" [hidden]="inprogress" aria-hidden="true" (click)="removeFile(i)"></i>
							</div>
						</div>
						<div *ngIf="file.ready == 'PENDING'" class="loader"></div>
					</div>
				</div>
				<div class="text-center" *ngIf="!uploadFiles || uploadFiles.length < 1">
					<span><em>{{LOCALIZATION.addThumbnailUploadFile}}</em></span>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
	<button class="btn btn-primary" type="button" (click)="upload()" [disabled]="inprogress">
		<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
		{{LOCALIZATION.submit}}
	</button>
</div>